export const sietepalabras = {
	nombre: "Siete Palabras",
	dia: "Viernes Santo",
	nombrecompleto:
		"Venerable y Mercedaria Hermandad de Penitencia de las Siete Palabras del Santísimo Cristo de la Sed y María Santísima de la Piedad",
	sede: "Parroquia de Ntra. Sra. de la Merced",
	pasos: 2,
	distancia: [967, 1290],
	penitentes: 80,
	cargadores: 64,
	web: "http://www.diariodecadiz.es/semana_santa/Palabras_0_1229577733.html",

	ida: [
		{ lng: -6.2913895, lat: 36.5284738 },
		{ lng: -6.291199, lat: 36.5284048 },
		{ lng: -6.291132, lat: 36.5285859 },
		{ lng: -6.2914833, lat: 36.5287992 },
		{ lng: -6.2921754, lat: 36.5290493 },
		{ lng: -6.29217, lat: 36.5291506 },
		{ lng: -6.2925683, lat: 36.5293984 },
		{ lng: -6.2925026, lat: 36.5295579 },
		{ lng: -6.2927923, lat: 36.529795 },
		{ lng: -6.2919581, lat: 36.5304631 },
		{ lng: -6.2926561, lat: 36.5312492 },
		{ lng: -6.292925, lat: 36.5310811 },
		{ lng: -6.2922075, lat: 36.5302853 },
		{ lng: -6.2928177, lat: 36.5298014 },
		{ lng: -6.2929612, lat: 36.5298225 },
		{ lng: -6.2931014, lat: 36.529809 },
		{ lng: -6.2932576, lat: 36.5297422 },
		{ lng: -6.2936217, lat: 36.5297034 },
		{ lng: -6.2945256, lat: 36.5296344 },
		{ lng: -6.2946095, lat: 36.5295541 },
		{ lng: -6.2950587, lat: 36.5296269 },
		{ lng: -6.295284, lat: 36.5290191 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.295689, lat: 36.5291268 },
		{ lng: -6.2954101, lat: 36.5297497 },
		{ lng: -6.2956622, lat: 36.5299588 },
		{ lng: -6.295276, lat: 36.5303575 },
		{ lng: -6.2950104, lat: 36.5308424 },
		{ lng: -6.2949193, lat: 36.5308468 },
		{ lng: -6.29493, lat: 36.5314588 },
		{ lng: -6.2964132, lat: 36.5317627 },
		{ lng: -6.2964106, lat: 36.531864 },
		{ lng: -6.2967901, lat: 36.5325408 },
		{ lng: -6.2972475, lat: 36.5319228 },
		{ lng: -6.2973568, lat: 36.5315502 },
		{ lng: -6.297501, lat: 36.5312034 },
		{ lng: -6.2971642, lat: 36.5310483 },
		{ lng: -6.2966627, lat: 36.5307939 },
		{ lng: -6.2963019, lat: 36.530573 },
		{ lng: -6.2957253, lat: 36.5299792 },
		{ lng: -6.2953504, lat: 36.5296527 },
		{ lng: -6.2946091, lat: 36.529525 },
		{ lng: -6.2945094, lat: 36.5296077 },
		{ lng: -6.2932563, lat: 36.5297217 },
		{ lng: -6.2931001, lat: 36.5297955 },
		{ lng: -6.2929629, lat: 36.5298066 },
		{ lng: -6.2928266, lat: 36.5297857 },
		{ lng: -6.2925285, lat: 36.5295554 },
		{ lng: -6.292598, lat: 36.5293885 },
		{ lng: -6.2921949, lat: 36.5291375 },
		{ lng: -6.2922006, lat: 36.5290266 },
		{ lng: -6.2914906, lat: 36.5287814 },
		{ lng: -6.2911631, lat: 36.5285775 },
		{ lng: -6.2912132, lat: 36.52844 },
		{ lng: -6.291372, lat: 36.5284953 }
		// ...
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-30T18:15",
			latlng: [36.52847, -6.29136]
		},
		{
			name: "Nueva",
			hora: "2018-03-30T19:45",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-30T20:45",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-30T21:45",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-30T22:15",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-30T22:25",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Merced",
			"Plaza de las Canastas",
			"Jesús de la Sentencia",
			"San Juan de Dios",
			"Plaza de San Juan de Dios",
			"4 de Diciembre de 1977",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Barrie (izq.)"],
		[
			"Plaza Topete",
			"Compañía",
			"Plza Pio XII",
			"Pelota",
			"Plaza San Juan de Dios",
			"San Juan de Dios",
			"Jesús de la Sentencia",
			"Plaza de las Canastas",
			"Merced"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/sietepalabras.js